import Accounting from '../../mixins/accounting';
import ProductDetailsSimplified from './ProductDetailsSimplified';

export default {
    name: 'product-details',

    props: ['product', 'currencyIsChanging', 'showTermsAndConditions'],

    mixins: [Accounting],

    components: {ProductDetailsSimplified},

    template: `
        <product-details-simplified
            :class="{'product-details--highlighted': product.type === 'PMP' }"
            :currencyIsChanging="currencyIsChanging"
            :showTermsAndConditions="showTermsAndConditions"
            :product="product">
        </product-details-simplified>
    `,
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/Components/quotes/ProductDetails.js